// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__EGQ+K","Menu":"SiderContentC_Menu__NxPHS"};